export const checkActiveModule = module => module === true
